export class LoaderConstants {
  public static HEADER = 'X-Skip-Count';
  public static SKIP_LOADER_HEADER = {headers: { 'X-Skip-Count': 'true' }};
}

